import api, { ApiError } from '@/apis'
import { API_PREFIX } from '@/constants'
import type { GetSealedOrderDetailResponse } from '@/payment/types'

/**
 * 가장 최근 밀봉비닐 주문 상세 조회 — GET /order/api/v2/product-orders/detail.
 *
 * 백엔드가 사용자의 가장 최근 밀봉비닐 주문 1건을 풍부한 형태(orderInfo + deliveryInfo + paymentInfo)로 반환.
 * 결제 완료 직후 진입 시 활성 주문 판별 및 detail 화면에 사용.
 *
 * 활성 주문 없는 사용자: 백엔드가 404 ("존재하지 않는 주문정보입니다") 응답 →
 * 정상 케이스(landing 으로 진입)이므로 null 로 정규화. axios 인터셉터가 AxiosError 를
 * ApiError 로 변환하므로 ApiError.status 로 검사.
 */
export const apiGetSealedOrderDetail = async (): Promise<GetSealedOrderDetailResponse | null> => {
  try {
    return await api.get<GetSealedOrderDetailResponse>(`${API_PREFIX.ORDER}/product-orders/detail`)
  } catch (error) {
    if (error instanceof ApiError && error.status === 404) {
      return null
    }
    throw error
  }
}
